import { render, staticRenderFns } from "./NewsIssues.vue?vue&type=template&id=cd209dd6"
import script from "./NewsIssues.js?vue&type=script&lang=js&external"
export * from "./NewsIssues.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports